import imageBanner from './img/banner.png'
import imageArchitecture from './img/architecture.jpg'
import imageTable from './img/table.jpg'
import { ProductProps } from '../../type'
import { ProductCategory, ProductTag } from '../../enum'

export const caruscee500: ProductProps = {
  tag: ProductTag.ESS,
  category: ProductCategory.CommercialEnergyStorageSystems,
  pathName: 'carus-cee500',
  banner: imageBanner,
  title: 'Carus-CEE500',
  description:
    'System Includes: Inverter, battery trays, racks, BMS,\nEMS hardware and software, HVAC, fire suppression, isolation transformer and outdoor enclosure',
  features: [
    {
      type: 'card-list',
      content: [
        {
          icon: 'safety',
          title: 'Multi-level Protection & Safest Chemistry',
          description: [
            'An integrated,multi-level Battery Manage ment System (BMS) monitors,optimizes, and balances system.',
            'Lithium iron phosphate (LFP) chemistry provides the highest level of safety, thermal stability, and reliability.',
          ],
        },
        {
          icon: 'solution',
          title: 'Turnkey Solution',
          description: [
            'Fully integrated, pre-configured system reduces on-site installation',
            'time. Package includes inverter, battery trays, software,fire suppression and enclosure.',
          ],
        },
        {
          icon: 'inverter',
          title: 'String-Inverter Architecture',
          description: [
            'Individual inverters for smaller sections of storage systems offer fault isolation, increased reliability,and enhanced management.',
          ],
        },
        {
          icon: 'cots',
          title: 'O-the-Shelf Energy Management System',
          description: [
            'Built-in Energy Management System (EMS) that can be configured for backup power,self consumption,time of use and more.',
          ],
        },
        {
          icon: 'customization',
          title: 'Customization',
          description: [
            'Multiple power and energy configurations. Modular, scalale design for precise project sizing.',
          ],
        },
        {
          icon: 'warranty',
          title: 'Warranty',
          description: ['5 years standard, 10 to 20 years extended.'],
        },
        {
          icon: 'certification',
          title: 'Certification',
          description: ['UN38.3, UL9540A, UL 1973, UL 1741-SB, UL 9540.'],
        },
      ],
    },
    {
      type: 'image-list',
      content: [{ images: [imageArchitecture] }],
    },
  ],
  specImages: [imageTable],
}
